// src/lib/managers/music/types/const.ts

import { MUSIC_CDN_URL } from "./const";

type MusicTrack = {
    title: string;
    url: string;
};

type MusicTracks = MusicTrack[];

export const availableTracks: MusicTracks = [
    {
        title: "instrospection",
        url: MUSIC_CDN_URL + "amsound-instrospection.mp3",
    },
    {
        title: "gravity",
        url: MUSIC_CDN_URL + "andybird-gravity.mp3",
    },
    {
        title: "allaroundus",
        url: MUSIC_CDN_URL + "danphillipson-allaroundus.mp3",
    },
    {
        title: "longroad",
        url: MUSIC_CDN_URL + "evertzeevalkink-longroad.mp3",
    },
    {
        title: "Brighter Than Ever",
        url: MUSIC_CDN_URL + "Nick Petrov - Brighter Than Ever.mp3",
    },
    {
        title: "Curious Child",
        url: MUSIC_CDN_URL + "Roger Gabalda - Curious Child.mp3",
    },
    {
        title: "Legends Will Rise",
        url: MUSIC_CDN_URL + "Roger Gabalda - Legends Will Rise.mp3",
    },
    {
        title: "The Rise of a Hero",
        url: MUSIC_CDN_URL + "Roger Gabalda - The Rise of a Hero.mp3",
    },
    {
        title: "Longing",
        url: MUSIC_CDN_URL + "Sasha Louis Leger - Longing.mp3",
    },
    {
        title: "Stellar Catharsis",
        url: MUSIC_CDN_URL + "Sonobringer - Stellar Catharsis.mp3",
    },
    {
        title: "This Is Your Time",
        url: MUSIC_CDN_URL + "This Is Your Time.mp3",
    },
    {
        title: "The Universe's Embrace",
        url: MUSIC_CDN_URL + "Tungsten Stars - The Universe's Embrace.mp3",
    },
    {
        title: "Whispers of Home",
        url: MUSIC_CDN_URL + "Tungsten Stars - Whispers of Home.mp3",
    },
    {
        title: "Elevation",
        url: MUSIC_CDN_URL + "Veace D - Elevation.mp3",
    },
    {
        title: "Lost in the Haze",
        url: MUSIC_CDN_URL + "Veace D - Lost in the Haze.mp3",
    },
    {
        title: "Oblivion",
        url: MUSIC_CDN_URL + "Veace D - Oblivion.mp3",
    },
    {
        title: "Closer to the Sun",
        url: MUSIC_CDN_URL + "Veance D - Closer to the Sun.mp3",
    },
    {
        title: "easy",
        url: MUSIC_CDN_URL + "vital-easy.mp3",
    },
    {
        title: "About U",
        url: MUSIC_CDN_URL + "Yari - About U.mp3",
    },
];

// Exports
export type { MusicTrack, MusicTracks };
